import React from 'react'
import '../globalOverrides.css'
import LoadingSpinner from '../LoadingSpinner'
import NavigationLoading from './NavigationLoading'

const LayoutLoading = () => {
  return (
    <React.Fragment>
      <NavigationLoading />
      <div id="main">
        <div>
          <LoadingSpinner />
        </div>
      </div>
    </React.Fragment>
  )
}

export default LayoutLoading
